export const CONSTANTS = {
  AMERICAN_DATETIME_FORMAT: 'mm/dd/yyyy hh:mm',
  EUROPIAN_DATETIME_FORMAT: 'dd-mm-yyyy hh:mm',
  BACKEND_AMERICAN_DATE_TIME_FORMAT: 'MM/DD/yyyy hh:mm a',
  BACKEND_EUROPIAN_DATE_TIME_FORMAT: 'DD-MM-yyyy HH:mm',
  AMERICAN_DATE_FORMAT: 'MM/DD/yyyy',
  EUROPIAN_DATE_FORMAT: 'DD-MM-yyyy',
  BACKEND_12_HOUR_TIME_FORMAT: 'a',
};
